























































































































import QuizBase from "@tt-app/components/exercise/QuizBase";
import { getAuthInfo, nextExerciseRouter } from "@tt-app/utils";
import { api } from "@tt-app/api";
import { EXERCISE_TYPE, ENTER_KEY } from "@tt-app/constants";
import { Trophy } from "@tt-app/models";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import AssignmentCompletionModal from "@tt-app/components/assignment/AssignmentCompletionModal.vue";
import CorrectnessOverlay from "@tt-app/components/exercise/common/CorrectnessOverlay.vue";
import ExerciseHeaderTitle from "@tt-app/components/exercise/ExerciseHeaderTitle.vue";
import ExerciseFooter from "@tt-app/components/exercise/common/ExerciseFooter.vue";
import ExerciseInstructions from "@tt-app/components/exercise/common/ExerciseInstructions.vue";
import ExerciseScope from "@tt-app/components/exercise/ExerciseScope.vue";
import ExerciseScopeButtons from "@tt-app/components/exercise/ExerciseScopeButtons.vue";
import ExerciseTrophy from "@tt-app/components/exercise/common/ExerciseTrophy.vue";
import FeedbackPopup from "@tt-app/components/feedback/FeedbackPopup.vue";
import LayoutExercise from "@tt-app/layouts/LayoutExercise.vue";
import PracticeModeToast from "@tt-app/components/exercise/common/PracticeModeToast.vue";
import ReviewButtons from "@tt-app/components/exercise/drill/ReviewButtons.vue";
import TypingQuestion from "@tt-app/components/exercise/drill/TypingQuestion.vue";
import TypingQuestionReview from "@tt-app/components/exercise/drill/TypingQuestionReview.vue";
import TypingInput from "@tt-app/components/exercise/drill/TypingInput.vue";

import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import {
  LimitedModeDetails,
  Session,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

interface FooterButtons {
  action?: string;
  color?: string;
  text?: string;
}

interface Data {
  answer: string;
  answers: any;
  answerSubmitted: boolean;
  audioDecoderPlayer: AudioDecoderPlayer;
  audioPlayed: boolean;
  exercise: any;
  exerciseResult: any;
  exerciseType: number;
  feedbackFormVisible: boolean;
  limitedModeActive: boolean;
  trophyVisible: boolean;
  overlayVisible: boolean;
  currentQuestionCorrect: boolean | null;
  practiceMode: boolean;
  selectedUuids: string[];
  showPracticeModeToast: boolean;
  skipDisabled: boolean;
}

interface Methods {
  audioEndedHandler: () => void;
  component: (componentConfig: any) => string;
  displayPracticeModeToast: () => void;
  endExercise: () => void;
  handleFeedbackClose: () => void;
  handleStartPracticeClick: (
    { problemUuids }?: { problemUuids: string[] },
    tryAgain?: boolean
  ) => void;
  handleStartTestClick: (tryAgain: boolean) => void;
  logExerciseResponse: () => void;
  logSkippedExercise: () => void;
  onNextExercise: () => void;
  startExercise: () => void;
  updateAnswer: (event: Event) => void;
  handleSubmit: () => void;
  enterPressed: (event: KeyboardEvent) => void;
  onTryAgain: () => void;
  refreshAudioPlayer: () => void;
  registerExercisePractice: (
    { problemUuids }?: { problemUuids: string[] },
    tryAgain?: boolean
  ) => void;
  resetState: () => void;
  showOverlay: () => void;
  handleHideOverlay: () => void;
  handleSkipClicked: () => void;
  handleFooterButtonClick: (action: string) => void;
  preloadImageOnPage: (pageNum: number) => void;
  updateSelectedUuids: (uuids: string[]) => void;
}

interface Computed {
  accuracy: any;
  allCorrect: boolean;
  body: any;
  currentPage: any;
  currentQuestionIndex: number;
  exerciseScopePage: boolean;
  finalQuestion: any;
  footerButtons: {} | FooterButtons[];
  header: {
    courseTitle: string;
    chapterTitle: string;
    exerciseTitle: string;
    sectionTitle: string;
  };
  incorrectlyAnsweredQuestionUuids: any[];
  isReview: boolean;
  limitedModeDetails: LimitedModeDetails;
  pages?: any[];
  hasExerciseScope: boolean;
  scope: any;
  session: Session;
  showFeedbackForm: boolean;
  totalQuestions: number;
  trophy?: Trophy;
  footerButtonDisabled: boolean;
}

export default QuizBase.extend<Data, Methods, Computed>({
  name: "DrillTyping",
  components: {
    ReviewButtons,
    ExerciseTrophy,
    AssignmentCompletionModal,
    FeedbackPopup,
    ExerciseFooter,
    ExerciseHeaderTitle,
    ExerciseInstructions,
    ExerciseScope,
    ExerciseScopeButtons,
    LayoutExercise,
    PracticeModeToast,
    TypingQuestion,
    TypingQuestionReview,
    TypingInput,
    CorrectnessOverlay
  },
  beforeDestroy() {
    this.audioDecoderPlayer.destroy();
    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  data: function() {
    return {
      answer: "",
      answers: {},
      answerSubmitted: false,
      audioDecoderPlayer: new AudioDecoderPlayer({ audioContext }),
      audioPlayed: false,
      currentPageIndex: 0,
      exercise: {
        type: EXERCISE_TYPE.DRILL_TYPING
      },
      exerciseResult: undefined,
      exerciseType: EXERCISE_TYPE.DRILL_TYPING,
      feedbackFormVisible: true,
      limitedModeActive: false,
      icons: {
        correct: IconCorrect,
        incorrect: IconIncorrect
      },
      practiceMode: false,
      review: {},
      trophyVisible: false,
      overlayVisible: false,
      currentQuestionCorrect: null,
      selectedUuids: [],
      showPracticeModeToast: false,
      skipDisabled: true
    };
  },
  computed: {
    accuracy() {
      let numCorrectAnswers = 0;
      let numIncorrectAnswers = 0;
      let numSkipped = 0;

      const answers = this.answers;

      Object.values(answers).forEach((answer: any) => {
        if (answer.isCorrect) {
          numCorrectAnswers += 1;
        } else if (answer.isCorrect === false) {
          numIncorrectAnswers += 1;
        } else if (answer.skipped) {
          numSkipped += 1;
        }
      });

      return {
        numCorrectAnswers,
        numIncorrectAnswers,
        numSkipped
      };
    },
    allCorrect() {
      return !this.accuracy.numIncorrectAnswers && !this.accuracy.numSkipped;
    },
    body() {
      if (!this.currentPage) {
        return undefined;
      }
      return this.currentPage.body;
    },
    currentPage() {
      if (!this.pages) {
        return;
      }

      const page = this.pages[this.currentPageIndex];

      if (!page) {
        return;
      }

      return page;
    },
    currentQuestionIndex() {
      return this.hasExerciseScope ? this.currentPageIndex : this.currentPageIndex + 1;
    },
    exerciseScopePage() {
      if (!this.currentPage) {
        return true;
      }

      return this.currentPage.body[0].type === "EXERCISE_SCOPE";
    },
    finalQuestion() {
      if (!this.currentPage) {
        return false;
      }

      const nextPage = this.pages?.[this.currentPageIndex + 1];

      return !!(nextPage && nextPage.body[0].type === "REVIEW");
    },
    footerButtons() {
      if (!this.currentPage) {
        return {};
      }

      let footerDefinition = {
        buttons: [
          {
            action: "NEXT",
            color: "primary",
            text: this.finalQuestion
              ? this.$__("exercise.action.review")
              : this.$__("exercise.action.send")
          }
        ]
      };

      if (this.isReview && this.exerciseResult) {
        footerDefinition = this.review.footer[0];

        const buttons = footerDefinition.buttons;

        const nextExerciseButton = buttons.find(button => {
          return button.action === "NEXT_EXERCISE";
        });

        if (nextExerciseButton) {
          nextExerciseButton.text = this.nextExerciseButtonText;
        }
      }

      return footerDefinition.buttons;
    },
    header() {
      return {
        courseTitle: this.course?.title,
        chapterTitle: this.chapter?.title,
        exerciseTitle: this.exercise?.title,
        sectionTitle: this.section?.title
      };
    },
    incorrectlyAnsweredQuestionUuids() {
      const answers = Object.entries(this.answers);

      const incorrectOrSkipped = answers.reduce((accumulator: any, [uuid, accuracy]: any) => {
        if (!accuracy.isCorrect) {
          accumulator[uuid] = accuracy;
        }

        return accumulator;
      }, {});

      return Object.keys(incorrectOrSkipped);
    },
    isReview() {
      return this.currentPage && this.currentPage.body[0].type === "REVIEW";
    },
    limitedModeDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.LIMITED_MODE_DETAILS}`
      ];
    },
    pages() {
      if (!this.exercise?.pages) {
        return;
      }

      let pages: any[] = [...this.exercise.pages];

      if (this.selectedUuids.length > 0) {
        pages = pages.filter((page: any) => {
          return (
            page.footer?.[0]?.type !== "TEXT_INPUT" ||
            this.selectedUuids.includes(page.footer[0].problemUuid)
          );
        });
      }

      if (this.limitedModeActive) {
        pages = pages.filter((page: any) => {
          return page.body?.[0]?.type !== "EXERCISE_SCOPE";
        });
      }

      return pages;
    },
    hasExerciseScope() {
      return this.pages?.[0]?.body?.[0]?.type === "EXERCISE_SCOPE";
    },
    scope() {
      return this.exercise.scope;
    },
    session() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    },
    showFeedbackForm() {
      return this.feedbackFormVisible && this.isReview;
    },
    totalQuestions() {
      const questions = this.pages?.filter(({ footer }: any) => {
        return footer.find((element: any) => {
          return element.problemUuid !== undefined;
        });
      });

      return questions?.length || 0;
    },
    trophy() {
      if (!this.exerciseResult) {
        return undefined;
      }
      const { numIncorrectAnswers, numCorrectAnswers, numSkipped } = this.accuracy;

      const trophyComments: { [key: string]: string } = {
        3: "ex.trophy.gold",
        2: "ex.trophy.silver",
        1: "ex.trophy.bronze"
      };

      const comment = this.$__(
        trophyComments[this.exerciseResult.trophy],
        this.exerciseResult.moreCorrectAnswers
      );

      return {
        comment,
        correctCount: numCorrectAnswers,
        incorrectCount: numIncorrectAnswers,
        score: this.exerciseResult.trophy,
        skippedCount: numSkipped
      };
    },
    footerButtonDisabled() {
      return this.answerSubmitted || this.overlayVisible || (!this.isReview && !this.answer);
    }
  },
  methods: {
    audioEndedHandler() {
      this.audioPlayed = true;
    },
    component(componentConfig) {
      const components = {
        CARD: "typing-question",
        CHAT_TEXT: "exercise-instructions",
        REVIEW: "typing-question-review",
        EXERCISE_SCOPE: "exercise-scope"
      };

      const { type }: { type: "CHAT_TEXT" | "CARD" } = componentConfig;

      return components[type];
    },
    displayPracticeModeToast() {
      this.showPracticeModeToast = true;

      window.setTimeout(() => {
        this.showPracticeModeToast = false;
      }, 5000);
    },
    async endExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);

      const params = {
        ...authInfo,
        logId: this.logId,
        ...this.accuracy,
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType
      };

      const response: any = await api.exercise.endExercise(params);
      const { reviewPage, ...results } = response;

      const answeredProblemUuids = Object.keys(this.answers);
      const reviewQuestions = reviewPage.body.filter((reviewComponent: any) => {
        const answerExplanation = reviewComponent.body.find(
          (component: any) => component.type === "TYPING_DRILL_ANSWER_EXPLANATION"
        );
        const problemUuid = answerExplanation.problemUuid;
        return answeredProblemUuids.includes(problemUuid);
      });

      reviewPage.body = reviewQuestions;

      this.review = reviewPage;
      this.exerciseResult = results;
      this.nav.requireExitConfirmation = false;
    },
    handleFeedbackClose() {
      this.feedbackFormVisible = false;
    },
    async handleStartPracticeClick(problemUuids, tryAgain) {
      if (!problemUuids) {
        await this.registerExercisePractice({ problemUuids: this.selectedUuids }, tryAgain);
      } else {
        await this.registerExercisePractice(problemUuids, tryAgain);
      }

      this.practiceMode = true;
      this.displayPracticeModeToast();

      this.resetState();
      if (this.hasExerciseScope) {
        /*
        This method is called in 2 parts.

        1. Exercise scope footer
          In this case, hasExerciseScope is always true and incrementPage must be called to move on

        2. onTryAgain()
          In this case, exercise scope must be skipped.
        */
        this.incrementPage();
      }
      this.practiceMode = true;
    },
    async handleStartTestClick(tryAgain) {
      if (tryAgain) {
        await this.startExercise();
      }

      this.selectedUuids = [];
      this.resetState();

      if (this.hasExerciseScope) {
        // Same as handleStartPracticeClick()
        this.incrementPage();
      }
    },
    async logExerciseResponse() {
      this.answerSubmitted = true;

      const params = {
        logId: this.logId,
        problemUuid: this.currentPage.footer[0].problemUuid,
        answer: this.answer,
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType
      };

      const authInfo = await getAuthInfo(this.$store.getters);

      const payload: any = {
        ...authInfo,
        ...params
      };

      const answer: any = await api.exercise.submitAnswer(payload);
      this.answers = {
        ...this.answers,
        [this.currentPage.footer[0].problemUuid]: { ...answer, submittedAnswer: this.answer }
      };
      this.audioPlayed = false;
      this.currentQuestionCorrect = answer.isCorrect;
      this.showOverlay();
      if (this.finalQuestion) {
        await this.endExercise();
      }

      this.answerSubmitted = false;
    },
    onNextExercise() {
      nextExerciseRouter({
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid,
        ...this.nextExercise
      });
    },
    async preloadImageOnPage(pageNum: number) {
      if (pageNum < this.exercise.pages.length) {
        this.exercise.pages[pageNum].body.forEach((element: any) => {
          if (element.type == "CARD") {
            element.body.forEach((cardElem: any) => {
              if (cardElem.type == "IMAGE") {
                const img = new Image();
                img.src = cardElem.url;
              }
            });
          }
        });
      }
    },
    async logSkippedExercise() {
      this.answerSubmitted = true;

      const params = {
        logId: this.logId,
        problemUuid: this.currentPage.footer[0].problemUuid,
        skipped: true,
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType
      };

      const authInfo = await getAuthInfo(this.$store.getters);

      const payload: any = {
        ...authInfo,
        ...params
      };
      const answer: any = await api.exercise.submitAnswer(payload);
      this.answers = {
        ...this.answers,
        [this.currentPage.footer[0].problemUuid]: {
          ...answer,
          submittedAnswer: null,
          skipped: true
        }
      };
      this.audioPlayed = false;

      if (this.finalQuestion) {
        await this.endExercise();
      }

      this.answerSubmitted = false;
      this.skipDisabled = false;
    },
    async onTryAgain() {
      const tryAgain = true;

      if (this.limitedModeActive || this.allCorrect) {
        await this.handleStartTestClick(tryAgain);
      } else {
        await this.handleStartPracticeClick(
          { problemUuids: this.incorrectlyAnsweredQuestionUuids },
          tryAgain
        );
      }
      await this.loadExercise();
    },
    refreshAudioPlayer() {
      if (document.visibilityState === "visible") {
        console.log("refreshing audio player");
        this.audioDecoderPlayer = new AudioDecoderPlayer({ audioContext });
      }
    },
    async registerExercisePractice(problemUuids, tryAgain) {
      const authInfo = await getAuthInfo(this.$store.getters);
      const details = {
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType,
        logId: tryAgain ? undefined : this.logId,
        ...problemUuids
      };

      const apiPayload = { ...authInfo, ...details };

      const response: any = await api.exercise.startExercisePractice(apiPayload);

      this.selectedUuids = problemUuids ? problemUuids.problemUuids : [];

      this.logId = response.logId;
      this.nav.requireExitConfirmation = true;
    },
    resetState() {
      this.answer = "";
      this.answers = {};
      this.exerciseResult = undefined;
      this.practiceMode = false;
      this.currentPageIndex = 0;
      this.feedbackFormVisible = true;
    },
    async startExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);
      const details = {
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType,
        limitedModeId: this.session?.limitedMode?.id,
        sessionId: this.session?.id
      };

      const apiPayload = { ...authInfo, ...details };

      const response: any = await api.exercise.startExercise(apiPayload);

      this.logId = response.logId;
      this.nav.requireExitConfirmation = true;
      this.skipDisabled = false;
    },
    updateAnswer(event) {
      const newValue = (event.target as HTMLInputElement).value;

      const validInput = new RegExp(/^[a-zA-Z0-9-_‘’'`＇.,~:;?!&%$#@+=*^ ]*$/).test(newValue);

      if (validInput) {
        this.answer = "-";
        this.answer = newValue.replace(/\s+/g, " ");
      } else {
        this.answer = "-";
        this.answer = "";
      }
    },
    handleSubmit() {
      this.skipDisabled = true;
      this.audioDecoderPlayer.stop();
      this.logExerciseResponse();
    },
    enterPressed(event) {
      if (event.keyCode === ENTER_KEY && !this.footerButtonDisabled) {
        if (!this.isReview) {
          this.handleSubmit();
        }
      }
    },
    showOverlay() {
      this.overlayVisible = true;
    },
    async handleHideOverlay() {
      this.incrementPage();
      this.overlayVisible = false;
      this.currentQuestionCorrect = null;
      this.skipDisabled = false;
    },
    handleSkipClicked() {
      if (!this.isReview) {
        this.skipDisabled = true;
        this.onActionBtnClick("SKIP");
      }
    },
    handleFooterButtonClick(action: string) {
      action === "NEXT" ? this.handleSubmit() : this.onActionBtnClick(action);
    },
    updateSelectedUuids(uuids) {
      this.selectedUuids = uuids;
    }
  },
  watch: {
    exercise() {
      this.startExercise();
      this.preloadImageOnPage(1);
    },
    currentPageIndex(new_val) {
      this.preloadImageOnPage(new_val + 1);
    },
    limitedModeDetails: {
      handler(newValue, oldValue) {
        if (newValue && !oldValue) {
          this.limitedModeActive = true;
        } else if (!newValue && oldValue) {
          this.limitedModeActive = false;
        }
      },
      immediate: true
    }
  },
  created() {
    document.addEventListener("keyup", this.enterPressed);
    document.addEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  destroyed() {
    document.removeEventListener("keyup", this.enterPressed);
    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  }
});
